export default __webpack_public_path__ + "static/media/ic_default_profile_pic_round.2c488b3c.svg";